import Vue from 'vue'

import { logdata } from '@tencent/midas-cgi'
import { getParam } from '@tencent/midas-util'

import dic from '@/constants/pf-dictionary'

/**
 * 在每个 page 页中加入 上报方法
 */
const Report = {
  install(vue: typeof Vue, { openid }) {
    vue.prototype.logData = async (params: Record<number, string>) => {
      logdata({
        3: openid,
        31: 'MidasFulizhuanqu1.0',
        26: `${getParam('pf')}`,
        ...params
      })
    }

    const log = async (iformat: string, resultInfo?: Record<string, string | number>) => {
      logdata({
        3: openid,
        // 31 device
        31: 'MidasFulizhuanqu1.0',
        // 26 offer_platform
        26: `${getParam('pf')}`,
        // 21 iformat
        21: iformat,
        // 8 result_info
        8: resultInfo
      })
    }
    vue.prototype.log = log

    vue.prototype.logPageView = async (key: keyof typeof dic.pageView, resultInfo?: Record<string, string | number>) => {
      await log(dic.pageView[key], resultInfo)
    }

    vue.prototype.logClick = async (key: keyof typeof dic.click, resultInfo?: Record<string, string | number>) => {
      await log(dic.click[key], resultInfo)
    }
  }
}

export default Report
